import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Form, Checkbox, Header, Icon, Segment } from "semantic-ui-react";

class TabletConfiguration extends Component {
  handleCheckboxChange = (e, { name, checked }) => {
    let { location, onLocationChange } = this.props;

    onLocationChange({ ...location, [name]: checked });
  };

  render() {
    const { location, isDealersAdminPage, t } = this.props;

    return (
      <Segment>
        <Header as="h5">
          <Icon name="settings" />
          <Header.Content>{t("tablet").message || "Tablet"}</Header.Content>
        </Header>
        <Form>
          <Form.Field>
            <Checkbox
              checked={location.is_assigned_wo_status_change_notification_enabled}
              name="is_assigned_wo_status_change_notification_enabled"
              label={t("notify_change_of_status_on_assigned_wo").message || "Notify change of status on assigned WO"}
              onChange={this.handleCheckboxChange}
            />
          </Form.Field>
          {isDealersAdminPage && (
            <Form.Field>
              <Checkbox
                checked={location.is_tablet_translation_ai_enabled}
                name="is_tablet_translation_ai_enabled"
                label={t("translation_ai_on_tablet").message || "Translation AI on tablet"}
                onChange={this.handleCheckboxChange}
              />
            </Form.Field>
          )}
        </Form>
      </Segment>
    );
  }
}

export default withTranslation()(TabletConfiguration);
